import { render, staticRenderFns } from "./IconXCircleOutline.vue?vue&type=template&id=be7eb56e"
import script from "./IconXCircleOutline.vue?vue&type=script&lang=js"
export * from "./IconXCircleOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports